import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import invite from "./invite";
import inviteForm from "./invite-form/invite-form";
import inviteHistory from "./invite-history/invite-history";

angular
    .module('invitesControl.component', [
        angularUIB,
        core,
        invite,
        inviteForm,
        inviteHistory
    ])
    .component('invitesControl', {
        template: require('./invites-control.component.html'),
        controller: ['Invite', 'notifier', '$uibModal', 'Auth', 'Data', controller],
        bindings: {
            params: '<',
            agregator: '<',
            newRegisterRequests: '<',
            activeInvitesCount: '<',
        }
    });

function controller(Invite, notifier, $uibModal, Auth, Data) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.id = null;
        $ctrl.search = null;
        $ctrl.organization = null;
        $ctrl.status = null;
        if ($ctrl.params.id) {
            $ctrl.id = $ctrl.params.id;
        }
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.getList = function () {
        Invite
            .getList({
                currentPage: $ctrl.currentPage,
                id: $ctrl.id,
                search: $ctrl.search,
                organization_id: $ctrl.organization ? $ctrl.organization.id : null,
                status: $ctrl.status
            })
            .then(
                function (response) {
                    $ctrl.totalCount = response.data.totalCount;
                    $ctrl.invites = response.data.invites;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            )
    };

    $ctrl.openForm = function (inputInvite) {
        $uibModal
            .open({
                component: 'inviteForm',
                resolve: {
                    inputInvite: function () {
                        return inputInvite;
                    },
                    agregator: function () {
                        return $ctrl.agregator;
                    }
                }
            })
            .result
            .then(function (result) {
                result.logs = [];
                result.logs.push({
                    user: Auth.user,
                    added_on: new Date(),
                    operation: 'create'
                });
                $ctrl.invites.unshift(result);
                $ctrl.activeInvitesCount++;
            });
    };

    $ctrl.openHistory = function (invite) {
        $uibModal.open({
            component: 'inviteHistory',
            resolve: {
                invite: function () {
                    return invite;
                }
            }
        });
    };

    $ctrl.retrySend = function (invite) {

        if (invite.inviteLoading) {
            return;
        }

        if (!confirm('Вы действительно хотите переотправить запрос?')) {
            return;
        }

        invite.inviteLoading = true;

        Invite.retrySend(invite.id).then(
            function () {
                invite.inviteLoading = false;
                invite.logs.push({
                    user: Auth.user,
                    added_on: new Date(),
                    operation: 'retry-send',
                });
                notifier.successNotify('Приглашение успешно отправилось');
            },
            function (error) {
                invite.inviteLoading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };

    $ctrl.cancel = function (invite) {

        if (invite.inviteLoading) {
            return;
        }

        if (!confirm('Вы действительно хотите отменить запрос?')) {
            return;
        }

        invite.inviteLoading = true;

        Invite.cancel(invite.id).then(
            function () {
                invite.status = 'canceled';
                invite.logs.push({
                    user: Auth.user,
                    added_on: new Date(),
                    operation: 'cancel',
                });
                invite.inviteLoading = false;
                notifier.successNotify('Приглашение успешно отменено', 2000);
            },
            function (error) {
                notifier.errorResponseNotify(error);
                invite.inviteLoading = false;
            }
        );
    };

    $ctrl.deleteInvite = function (invite, ind) {

        if (invite.inviteLoading) {
            return;
        }

        if (!confirm('Вы действительно хотите удалить запрос?')) {
            return;
        }

        invite.inviteLoading = true;

        Invite.destroy(invite.id).then(
            function () {
                $ctrl.invites.splice(ind, 1);
                notifier.successNotify('Приглашение успешно удалено', 2000);
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        );
    };
}

export default 'invitesControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/invites-control/invites-control.component.js